"use strict";
/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
